import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const About = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const accountNotFoundError = "Account not found. Please register first.";
  const showRegisterPrompt = error === accountNotFoundError;

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await axios.post(
        `${config.API_BASE_URL}${config.ADMIN.LOGIN}`,
        { email, password }
      );

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("adminID", res.data.adminID);

      navigate(res.data?.redirectTo || "/admin/home");

    } catch (err) {
      setError(
        err.response?.data?.error ||
        "Login failed. Please check your credentials."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <form style={card} onSubmit={login}>
        <h2 style={title}>Admin Login</h2>
        <p style={subtitle}>
          Sign in to manage groups and users
        </p>

        {error && (
          <div style={errorBox}>
            <p style={errorText}>
              {showRegisterPrompt
                ? "No account exists for this email. Please register as a Kin-Keeper first."
                : error}
            </p>
            {showRegisterPrompt ? (
              <button
                type="button"
                style={errorLinkBtn}
                onClick={() => navigate("/admin/register")}
              >
                Register Kin-Keeper
              </button>
            ) : null}
          </div>
        )}

        <div style={inputGroup}>
          <label style={label}>Email</label>
          <input
            style={input}
            type="email"
            placeholder="admin@example.com"
            required
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </div>

        <div style={inputGroup}>
          <label style={label}>Password</label>
          <div style={passwordWrapper}>
            <input
              style={{ ...input, paddingRight: "42px" }}
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              required
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={eyeIcon}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <button style={button} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>

        <p style={footerText}>
          Don’t have an account?{" "}
          <span
            style={link}
            onClick={() => navigate("/admin/register")}
          >
            Register here
          </span>
        </p>
      </form>
    </div>
  );
};

export default About;

/* =====================
   STYLES
===================== */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #f4f9fd 0%, #ffffff 100%)",
  padding: "20px"
};

const card = {
  background: "#fff",
  padding: "40px",
  width: "100%",
  maxWidth: "400px",
  borderRadius: "16px",
  boxShadow: "0 10px 40px rgba(14, 85, 128, 0.08)",
  border: "1px solid #eef3f7",
  animation: "fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1)"
};

const title = {
  textAlign: "center",
  color: "#0E5580",
  fontSize: "2rem",
  fontWeight: "800",
  marginBottom: "8px",
  letterSpacing: "-0.01em"
};

const subtitle = {
  textAlign: "center",
  fontSize: "1rem",
  color: "#4f6475",
  marginBottom: "32px",
  lineHeight: "1.5"
};

const errorBox = {
  background: "#fdf2f1",
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #f0c9c4",
  marginBottom: "20px"
};

const errorText = {
  color: "#c0392b",
  textAlign: "center",
  fontSize: "14px",
  fontWeight: "500",
  margin: 0
};

const errorLinkBtn = {
  marginTop: "10px",
  background: "transparent",
  border: "none",
  color: "#0E5580",
  fontWeight: "700",
  cursor: "pointer",
  textDecoration: "underline",
  width: "100%"
};

const inputGroup = {
  marginBottom: "20px",
  display: "flex",
  flexDirection: "column"
};

const label = {
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "8px",
  color: "#12344d"
};

const input = {
  padding: "16px 18px",
  fontSize: "18px",
  borderRadius: "10px",
  border: "1px solid #cddde9",
  background: "#f9fbfd",
  transition: "border-color 0.2s, box-shadow 0.2s",
  outline: "none",
  boxSizing: "border-box",
  width: "100%",
  color: "#12344d"
};

const passwordWrapper = {
  position: "relative",
  display: "flex",
  alignItems: "center"
};

const eyeIcon = {
  position: "absolute",
  right: "16px",
  cursor: "pointer",
  color: "#6b8396",
  fontSize: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%"
};

const button = {
  width: "100%",
  minHeight: "52px",
  padding: "14px 16px",
  marginTop: "12px",
  background: "#0E5580",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  fontSize: "18px",
  fontWeight: "600",
  cursor: "pointer",
  transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
  boxShadow: "0 4px 14px rgba(14, 85, 128, 0.2)"
};

const footerText = {
  marginTop: "24px",
  textAlign: "center",
  fontSize: "15px",
  color: "#4f6475"
};

const link = {
  color: "#0E5580",
  cursor: "pointer",
  fontWeight: "600",
  textDecoration: "underline",
  textDecorationColor: "transparent",
  transition: "text-decoration-color 0.2s"
};
